import { REST_NOTIFICATION_BEFORE_DUE_DATE_EDIT } from '../../../../constants';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IGetState, TNBDId } from '../../../../../types/types';
import { fetchHandler } from '../../../../../util/fetchHandler';
import Util from '../../../../../util/util';
import { getRestHeadersPatch } from '../../../../helpers/getRestHeadersHelper';
import { INotificationBeforeDueDate } from '../../../../../store/model/notificationBeforeDueDate/types';
import { IRestNotificationBeforeDueDate } from '../../../../../types/rest/IRestNotificationBeforeDueDate';

export const patchRest = (
    notificationId: TNBDId,
    body: INotificationBeforeDueDate
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        body.id = notificationId;
        return fetchHandler<IRestNotificationBeforeDueDate>(
            Util.getApiUrl(REST_NOTIFICATION_BEFORE_DUE_DATE_EDIT + notificationId), {
                ...getRestHeadersPatch(),
                body: JSON.stringify(body)
            }
        );
    };
    return action;
};
